// Bottom bar "More" panel and organizations on the phone (task 1.12, D-044).
export const tenaxMobileEnglishMessages = {
  tenax: {
    mobile: {
      people: "People",
      more: "More",
      more_title: "Other sections",
      companies_search: "Search an organization",
      companies_empty: "No organizations",
      contacts_count: "%{smart_count} person |||| %{smart_count} people",
    },
  },
};

export const tenaxMobileItalianMessages = {
  tenax: {
    mobile: {
      people: "Persone",
      more: "Altro",
      more_title: "Altre sezioni",
      companies_search: "Cerca un'organizzazione",
      companies_empty: "Nessuna organizzazione",
      contacts_count: "%{smart_count} persona |||| %{smart_count} persone",
    },
  },
};
